import { useTranslation, Trans } from "react-i18next";

const CollectionAnomalyAlert = ({ anomaly }) => {
  const { t } = useTranslation();

  if (!anomaly) return null;

  const hasSavingsPotential =
    Number.isFinite(anomaly.savingsPotentialShare) &&
    anomaly.savingsPotentialShare > 0;

  return (
    <section className="statistics-alert statistics-alert--anomaly">
      <div className="flex flex-row items-start gap-3">
        <i className="fas fa-exclamation-triangle text-[#EEAC43] mt-1"></i>
        <div className="flex flex-col gap-2">
          <span className="font-semibold text-[#64481B]">
            {t("Anomaly detected")}
          </span>

          <div className="flex flex-col text-[#64481B] text-sm">
            {anomaly.scope === "flux" ? (
              <span>
                <Trans
                  i18nKey="anomaly.underObjectiveByFlux"
                  values={{
                    average: anomaly.average ?? anomaly.share,
                    flux: anomaly.fluxLabel,
                    objective: anomaly.objective ?? anomaly.threshold,
                    gap: anomaly.gap ?? anomaly.share,
                  }}
                  components={{
                    bold: <span className="font-semibold text-[#64481B]" />,
                  }}
                />
              </span>
            ) : (
              <span>
                {t("anomaly.underObjectiveGlobal", {
                  average: anomaly.average ?? anomaly.share,
                  objective: anomaly.objective ?? anomaly.threshold,
                  gap: anomaly.gap ?? anomaly.share,
                })}
              </span>
            )}
            {hasSavingsPotential && (
              <span>
                {t("anomaly.savingsPotential", {
                  savings: anomaly.savingsPotentialShare,
                })}
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollectionAnomalyAlert;
